// import React from "react";
// import { Handle } from "reactflow";

// const TriggerNode = ({ id, data }) => {
//   // Reuse the status styles
//   const statusStyles = {
//     idle: "",
//     pending: "border-yellow-400",
//     queued: "border-blue-400",
//     failed: "border-red-500",
//     success: "border-green-500",
//     running: "animate-[pulse_1s_infinite] border-green-500",
//     approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
//   };

//   // Default to 'idle' if status is not provided or invalid
//   const status = data?.status || "idle";

//   return (
//     <div
//       className={`relative p-4 bg-zinc-800 rounded-full shadow-md border text-zinc-100 flex items-center justify-center${
//         statusStyles[status] || ""
//       }`}
//       style={{ width: "250px", height: "250px" }}
//     >
//       <div className="flex items-center flex-col gap-4">
//         {data?.label && (
//           <img
//             src={appImages[data?.label.toLowerCase()]}
//             alt="Trigger icon"
//             className="w-4 h-4"
//           />
//         )}
//         <h3 className="font-bold text-lg">{data?.label}</h3> {id}
//       </div>
//       {data && data.events && data.events.length > 0 && (
//         <>
//           <p className="text-sm mt-2 font-semibold">Events:</p>
//           <ul className="text-sm list-disc pl-4">
//             {data.events.map((event, idx) => (
//               <li key={idx} className="text-zinc-100">
//                 {event}
//               </li>
//             ))}
//           </ul>
//         </>
//       )}
//       <Handle type="source" position="right" className="bg-blue-400" />
//     </div>
//   );
// };

// export default TriggerNode;

// const appImages = {
//   "workflow executor":"https://oqlous.inqbator.in/assets/oqlous.svg",
//   jira: "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228864/mentorEducationImages/x3hajcpo5sbpdb0klxvu.png",
//   gmail:
//     "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228561/mentorEducationImages/wbenqxucyj7mh0vsec5f.png",
//   github:
//     "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727456981/mentorEducationImages/cxyxczli60shycbxq2zo.png",
// };

import React from "react";
import { Handle } from "reactflow";

const TriggerNode = ({ id, data }) => {
  const statusStyles = {
    idle: "",
    pending: "border-yellow-400",
    queued: "border-blue-400",
    failed: "border-red-500",
    success: "border-green-500",
    running: "animate-[pulse_1s_infinite] border-green-500",
    approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
    diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
  };

  // Default to 'idle' if status is not provided or invalid
  const status = data?.status || "idle";
  
  // Get the first event if available
  const event = data?.events && data.events.length > 0 ? data.events[0] : null;

  return (
    <div
      className={`relative bg-zinc-800 rounded-full shadow-md border text-zinc-100 flex flex-col items-center justify-center ${
        statusStyles[status] || ""
      }`}
      style={{ width: "150px", height: "150px" }}
    >
      <div className="relative flex flex-col items-center justify-center h-full w-full p-4">
        {/* Top: Icon */}
        <div className="absolute top-4 bg-zinc-700 p-2 rounded-full mb-3">
          <img
            src={appImages[data?.label?.toLowerCase()] || appImages["workflow executor"]}
            alt="Trigger icon"
            className="w-6 h-6"
            style={{ objectFit: "contain" }}
          />
        </div>

        {/* Event Name */}
        {event && (
          <div className="bg-zinc-700 px-3 py-1 rounded-full max-w-[100%]">
            <span 
              className="text-xs truncate block text-center" 
              title={event}
              style={{ maxWidth: "120px" }}
            >
              {event}
            </span>
          </div>
        )}
      </div>

      <Handle 
        type="source" 
        position="right" 
        className="bg-blue-400 border-none" 
        style={{ right: "-6px", height: "10px", width: "10px" }}
      />
    </div>
  );
};

export default TriggerNode;

const appImages = {
  "workflow executor": "https://oqlous.inqbator.in/assets/oqlous.svg",
  jira: "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228864/mentorEducationImages/x3hajcpo5sbpdb0klxvu.png",
  gmail: "https://res.cloudinary.com/dsguoq6ad/image/upload/v1726228561/mentorEducationImages/wbenqxucyj7mh0vsec5f.png",
  github: "https://res.cloudinary.com/dsguoq6ad/image/upload/v1727456981/mentorEducationImages/cxyxczli60shycbxq2zo.png",
  // local assets
  teams: "assets/icons/teams_icon.png",
  outlook: "assets/icons/outlook.png",
};